import React, { useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import AdminSidebar from './adminsidebar';
import AdminHead from './adminhead';
import AdminSidebarMobile from './adminsidebarmobile';

const AdminLayout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    return (
        <div className='bg-gray-50 min-h-screen'>
            {/* Mobile */}
            <div className="flex md:hidden min-h-screen">
                <div className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity ${isSidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={toggleSidebar}></div>
                <AdminSidebarMobile isSidebarOpen={isSidebarOpen} />
                <div className="flex-1 flex flex-col">
                    <div className='flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200'>
                        <p className='font-black text-lg'>Admin Panel</p>
                        <button onClick={toggleSidebar} className='p-2 rounded-lg hover:bg-gray-100'>
                            {isSidebarOpen ? <FiX size={20} /> : <FiMenu size={20} />}
                        </button>
                    </div>
                    <div className='flex-1 overflow-y-auto'>
                        {children}
                    </div>
                </div>
            </div>

            {/* Desktop */}
            <div className='hidden md:flex h-screen'>
                <AdminSidebar />
                <div className='flex-1 flex flex-col overflow-hidden'>
                    <AdminHead />
                    <div className='flex-1 overflow-y-auto bg-gray-50'>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;
